export const TABLE_LENGTH = 10;

export const NUMBER_OF_FIELDS = TABLE_LENGTH * TABLE_LENGTH;

export const GAME_MODES = {
	CLASSIC: 'classic',
	CLICKOMANIA: 'clickomania',
	LEVELING: 'leveling',
};
